// import "./PricingSection.css";
// import { Link, NavLink } from "react-router-dom";
// import discountText from "../../assets/img/discount_offers/card-title.png";
// import domainIcon from "../../assets/img/discount_offers/domain-icon.png";
// import cpanelLogo from "../../assets/img/discount_offers/cpanel-logo.png";
// import vpsIcon from "../../assets/img/discount_offers/vps-icon.png";
// import storageIcon from "../../assets/img/discount_offers/cloud-storage-icon.png";

// const PricingCard = ({ icon, title, features, price,link }) => {
//   return (
//     <div className={`pricing-card text-center position-relative ${title === "cPanel" ? "cpanel-card" : ""}`}>

//       {/* Offer Badge */}
//       <span className="offer-badge">VICTORY DAY OFFER</span>

//       {/* Title pill */}
//       <div className="title-pill">{title}</div>

//       {/* Icon */}
//       <div className="icon-box">
//         <img src={icon} alt={title} className="img-fluid" />
//       </div>

//       {/* Features */}
//       {/* Features Box */}
//     <div className="offer-features-box">
//       {features.map((f, i) => (
//         <p key={i} className="feature-line">
//           {f.highlight && (
//             <span className="feature-highlight">{f.highlight}</span>
//           )}{" "}
//           {f.text}
//         </p>
//       ))}
//     </div>


//       {/* Price */}
//       <div className="offer-price-box">
//         <p className="small text-muted">Starting from</p>
//         <p className="offer-price">
//           <span className="currency">BDT</span> {price}
//           <span className="month">/month</span>
//         </p>
//       </div>

//       {/* Button */}
//       <Link to={`${link}`} className="btn learn-more-btn">Learn More</Link>
//     </div>
//   );
// };

// export default function PricingSection() {
//   const pricingData = [
//     {
//       icon: domainIcon,
//       title: "Domain",
//       features: [
//         { highlight: "Domain", text: "Registration" },
//         { highlight: "Domain", text: "Transfer" },
//       ],
//       price: "On Every Domain",
//       link: '/domain',
//     },
//     {
//       icon: cpanelLogo,
//       title: "cPanel",
//       features: [
//         { highlight: "6GB", text: "NVMe Space" },
//         { highlight: "Free", text: ".COM Domain" },
//         { highlight: "5", text: "Websites/Addon" },
//         { highlight: "Unlimited", text: "Bandwidth" },
//         { highlight: "100", text: "E-mail Account" },
//         { highlight: "Antivirus", text: "Support" },
//         { highlight: "TeamViewer", text: "Support" },
//       ],
//       price: "1599",
//       link: '/shared-hosting',
//     },
//     {
//       icon: vpsIcon,
//       title: "VPS",
//       features: [
//         { highlight: "10GB", text: "SSD Disk Space" },
//         { highlight: "1 Core", text: "vCPU" },
//         { highlight: "2 GB", text: "RAM" },
//         { highlight: "7500", text: "Visits/Month" },
//         { highlight: "Unlimited", text: "Bandwidth" },
//         { text: "1 Parked Domain" },
//         { text: "5 Added Domain" },
//         { highlight: "KVM", text: "Virtualization" },
//       ],
//       price: "749",
//        link: '/virtual-private-hosting',
//     },
//     {
//       icon: storageIcon,
//       title: "Storage",
//       features: [
//         { highlight: "30GB", text: "Cloud Storage" },
//         { highlight: "Unlimited", text: "BDIX" },
//         { highlight: "Unlimited", text: "Bandwidth" },
//       ],
//       price: "89",
//         link: '/storage',
//     },
//   ];

//   return (
//     <section className="pricing-section">
//       <div className="container">

//         {/* Discount Title Image */}
//         <div className="d-flex justify-content-center mb-4 mb-md-5">
//           <img
//             src={discountText}
//             className="discount-title"
//           />
//         </div>

//         {/* Cards Grid */}
//         <div className="row g-4">
//           {pricingData.map((card, i) => (
//             <div className="col-12 col-sm-6 col-lg-3 mb-5" key={i}>
//               <PricingCard {...card} />
//             </div>
//           ))}
//         </div>

//       </div>
//     </section>
//   );
// }


import React from "react";
import "./PricingSection.css";
import { Link, NavLink } from "react-router-dom";
import discountText from "../../assets/img/discount_offers/card-title.png";
import domainIcon from "../../assets/img/discount_offers/domain-icon.png";
import cpanelLogo from "../../assets/img/discount_offers/cpanel-logo.png";
import vpsIcon from "../../assets/img/discount_offers/vps-icon.png";
import storageIcon from "../../assets/img/discount_offers/cloud-storage-icon.png";

// ... (Keep your PricingCard component as is, but you might want to adjust it to show both original and discounted price)

// A revised PricingCard component to handle both original and current price (suggested change):
const PricingCard = ({ icon, title, features, originalPrice, currentPrice, link }) => {
  return (
    <div className={`pricing-card text-center position-relative ${title === "cPanel" ? "cpanel-card" : ""}`}>
      {/* Offer Badge */}
      <span className="offer-badge">VICTORY DAY OFFER</span>

      {/* Title pill */}
      <div className="title-pill">{title}</div>

      {/* Icon */}
      <div className="icon-box">
        <img src={icon} alt={title} className="img-fluid" />
      </div>

      {/* Features Box */}
    <div className="offer-features-box">
      {features.map((f, i) => (
        <p key={i} className="feature-line">
          {f.highlight && (
            <span className="feature-highlight">{f.highlight}</span>
          )}{" "}
          {f.text}
        </p>
      ))}
    </div>


      {/* Price */}
      <div className="offer-price-box">
        <p className="small text-muted">{title == "Domain"? currentPrice :'Starting from'}</p>
        {/* Conditional rendering for Domain card's offer text */}
          <p className="offer-price">
            {/* Original Price with strikethrough */}
            {title !== "Domain" && (
                <span className="original-price">{originalPrice} TK</span>
            )}
            
            {/* Current/Discounted Price */}
            <span className="current-price-value"> {title== "Domain"?'on Every Domain': currentPrice +' TK'} </span>
            {title !== "Domain" && (
            <p className="month"> {title === 'cPanel'? 'per year':'per month'}</p>)}
          </p>
      
      </div>

      {/* Button */}
      <Link to={`${link}`} className="btn learn-more-btn">Learn More</Link>
    </div>
  );
};


const PricingSection = React.forwardRef((props, ref) => {
  const pricingData = [
    {
      icon: domainIcon,
      title: "Domain",
      features: [
        { highlight: "Domain", text: "Registration" },
        { highlight: "Domain", text: "Transfer" },
      ],
      // Price for Domain card is the discount text
      currentPrice: "Get 16% Off",
      originalPrice: "on Every Domain ", // No original price to display
      link: '/domain',
    },
    {
      icon: cpanelLogo,
      title: "cPanel",
      features: [
        { highlight: "6GB", text: "NVMe Space" },
        { highlight: "Free", text: ".COM Domain" },
        { highlight: "5", text: "Websites/Addon" },
        { highlight: "Unlimited", text: "Bandwidth" },
        { highlight: "100", text: "E-mail Account" },
        { highlight: "Antivirus", text: "Support" },
        { highlight: "TeamViewer", text: "Support" }, // Added TeamViewer Support
      ],
      // Prices updated from image
      originalPrice: "1700",
      currentPrice: "1,428",
      link: '/shared-hosting',
    },
    {
      icon: vpsIcon,
      title: "VPS",
      features: [
        { highlight: "10GB", text: "SSD Disk Space" },
        { highlight: "1 Core", text: "vCPU" },
        { highlight: "2 GB", text: "RAM" },
        { highlight: "7500", text: "Visits/Month" },
        { highlight: "Unlimited", text: "Bandwidth" },
        { highlight: "1", text: "Parked Domain" }, // Added highlight
        { highlight: "5", text: "Added Domain" }, // Added highlight
        { highlight: "KVM", text: "Virtualization" },
      ],
      // Prices updated from image
      originalPrice: "800",
      currentPrice: "672",
       link: '/virtual-private-hosting',
    },
    {
      icon: storageIcon,
      title: "Storage",
      features: [
        { highlight: "30GB", text: "Cloud Storage" },
        { highlight: "Unlimited", text: "BDIX" },
        { highlight: "Unlimited", text: "Bandwidth" },
      ],
      // Prices updated from image
      originalPrice: "89",
      currentPrice: "75",
        link: '/storage',
    },
  ];

  return (
    <section className="pricing-section" ref={ref}>
      <div className="container">
        {/* Discount Title Image */}
        <div className="d-flex justify-content-center">
          <img
            src={discountText}
            className="discount-title"
          />
        </div>

        {/* Cards Grid */}
        <div className="row g-4">
          {pricingData.map((card, i) => (
            <div className="col-12 col-sm-6 col-lg-3 mb-5" key={i}>
              {/* Using the suggested revised PricingCard component */}
              <PricingCard {...card} />
            </div>
          ))}
        </div>

      </div>
    </section>
  );
});

export default PricingSection;